<div class="row">
  <div class="col-md-3">
    <div class="label form-label">{{attribute.name}} {{ attribute.required ? '*' : ''}}</div>
    <div class="description" *ngIf="attribute.description">{{attribute.description}}</div>
  </div>
  <div class="col-md-9">
    <div class="full" appearance="outline" color="warn">
      <form [formGroup]="formGroup" class="my-form">
        <ng-template matStepLabel>Add your services</ng-template>
        <!-- <mat-form-field>
          <input matInput placeholder="Address" formControlName="secondCtrl" required>
        </mat-form-field> -->
        <table mat-table [dataSource]="tableData.value" formArrayName="tableData" class="mat-elevation-z8">

          <ng-container matColumnDef="oneindex">
            <th mat-header-cell *matHeaderCellDef> # </th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i"> {{i+1}} </td>
          </ng-container>

          <ng-container [matColumnDef]="colOpt.name" *ngFor="let colOpt of columnOpts">
            <th mat-header-cell *matHeaderCellDef> {{colOpt.friendlyName}} </th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
              <input type="text" [formControlName]="colOpt.name" [placeholder]="colOpt.friendlyName">
            </td>
          </ng-container>

          <ng-container matColumnDef="btn">
            <th mat-header-cell *matHeaderCellDef>
              <button (click)="addRow()" mat-icon-button>
                <mat-icon class="green-color">add_circle_outline</mat-icon>
              </button>
            </th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
              <button (click)="removeRow(i)" mat-icon-button>
                <mat-icon color="warn">remove_circle_outline</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
          <tr mat-row *matRowDef="let row; columns: columnNames; let i = index"></tr>
        </table>

<!--        <button (click)="addRow()">add more...</button>-->
<!--        <pre>{{formGroup.value | json }}</pre>-->
        <div>
<!--          <button mat-button matStepperPrevious>Back</button>-->
<!--          <button mat-button matStepperNext>Next</button>-->
        </div>
      </form>
    </div>
  </div>
</div>



